import React from 'react'

type GuidesSearchProps = Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  'size' | 'prefix' | 'type' | 'onChange'
> &
  Partial<{
    className: string
    name: string
    placeholder: string
    type: string
    label: string
    icon: React.ReactNode
    onChange: (value: React.ChangeEvent<HTMLInputElement>) => void
  }>

const GuidesSearch = React.forwardRef<HTMLInputElement, GuidesSearchProps>(
  (
    {
      className = '',
      name = '',
      placeholder = '',
      type = 'text',
      label = '',
      icon,
      onChange,
      ...restProps
    },
    ref,
  ) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
      if (onChange) onChange(e)
    }

    return (
      <div className="flex w-full relative mb-3 overflow-hidden sm:max-w-md">
        {icon}
        <input
          ref={ref}
          type={type}
          name={name}
          onChange={handleChange}
          placeholder={placeholder}
          {...restProps}
          className="w-full py-2.5 pl-4 pr-12 rounded-lg border-grayscale-1 focus:outline-0 border-1 shadow-sm focus:border-blue-primary"
        />
      </div>
    )
  },
)

// Assigning a display name to the component
GuidesSearch.displayName = 'GuidesSearch'

export { GuidesSearch }
